import { PAGE_SIZE } from '../const';

interface Config {
  index: number;
  size?: number;
}

export const convertToProductCardAdBannerIndex = ({ index, size = PAGE_SIZE }: Config) => {
  return Math.floor((index - 25) / (2 * size));
};
